export function getApplicationRecordLocationDescription(
    applicationRecord,
    fieldsBySid,
) {
    return applicationRecord.fields
        .map(function (fieldSid) {
            return fieldsBySid[fieldSid].name;
        })
        .join(", ");
}

export function getFieldCropSids(fields) {
    return fields.reduce(function (allCropSids, field) {
        return allCropSids.concat(field.crops);
    }, []);
}
